import { useT } from '@transifex/react'
import { CalculateTaxErrorTypes } from '../../../../../queries/calculate-tax'
import { useAppSelector } from '../../../../../state/hooks'
import { selectCalculateTaxError } from '../../../../../state/slices/currentSale/currentSaleSlice'

const ADDRESS_ERROR_CONTEXT = 'Sale Line Item Expanded > Fulfilment Address'

export interface AutotaxErrorsProps {
  countryId: string | undefined
}

export const useAutotaxErrorsModel = ({ countryId }: AutotaxErrorsProps) => {
  const t = useT()
  const calculateTaxError = useAppSelector(selectCalculateTaxError)
  const isUS = countryId === 'US'

  if (
    !calculateTaxError ||
    calculateTaxError !== CalculateTaxErrorTypes.POSTCODE_NOT_IN_STATE
  ) {
    return { message: undefined }
  }

  const zipCodeTOptions = {
    _key: 'sale.line-item-expanded.fulfilment-address.zip-postal-code',
    _context: ADDRESS_ERROR_CONTEXT,
  }
  const stateProvinceTOptions = {
    _key: 'sale.line-item-expanded.fulfilment-address.state-province',
    _context: ADDRESS_ERROR_CONTEXT,
  }

  return {
    message: t(
      'Selected {zipOrPostalCode} and {stateOrProvince} do not match. Update them to enable automatic tax calculation.',
      {
        zipOrPostalCode: isUS
          ? t('ZIP code', zipCodeTOptions)
          : t('postal code', zipCodeTOptions),
        stateOrProvince: isUS
          ? t('state', stateProvinceTOptions)
          : t('state/province', stateProvinceTOptions),
        _key: 'sale.line-item-expanded.fulfilment-address.error',
        _context: ADDRESS_ERROR_CONTEXT,
      }
    ),
  }
}
